// 用户基础信息模块的数据清洗
// 注意：本 transform 同时承担了报告全局数据的预处理：
//   1. 疾病预警 syndrome_danger → bigData/big/little/littleData（供报告主页面使用）
//   2. 历史 index_list 的过滤 / 日期裁剪 / 反转（供报告主页面使用）
//   3. report_template_type==2 的 viscera / sick_text_array 兼容处理（供 Physique 等模块使用）
// 以上字段并非 UserInfo/index.vue 自身渲染所需，而是被报告其他区域消费。

export default function transform(data) {
    if (!data) return;

    // 1. syndrome_danger 加工
    const big = [];
    const little = [];
    const bigData = [];
    const littleData = [];
    for (const item in data.syndrome_danger) {
        const syndrome_danger = data.syndrome_danger;
        let hot = 0;
        for (let i = 0, n = syndrome_danger[item].list.length; i < n; i++) {
            if (syndrome_danger[item].list[i].risk_index) {
                hot++;
                little.push(syndrome_danger[item].list[i].disease_name);
                data.syndrome_danger[item].list[i].key = syndrome_danger[item].name;
                littleData.push(syndrome_danger[item].list[i]);
            }
        }
        if (hot > 0) {
            big.push(syndrome_danger[item].name);
            bigData.push(syndrome_danger[item]);
        }
    }
    data.bigData = bigData;
    data.big = big;
    data.little = little;
    data.littleData = littleData;

    // 2. index_list 历史数据
    if (data.index_list) {
        const bmi = [];
        const date = [];
        const score = [];
        data.index_list.score.map((scores, index) => {
            if (scores !== 0) {
                const sliceDate = data.index_list.date[index].split('-');
                bmi.push(data.index_list.bmi[index]);
                date.push(`${sliceDate[1]}-${sliceDate[2]}`);
                score.push(data.index_list.score[index]);
            }
        });
        data.index_list.bmi = bmi.reverse();
        data.index_list.date = date.reverse();
        data.index_list.score = score.reverse();
    }

    // 3. report_template_type==2 时使用 viscera.syndrome_name2 / syndrome_desc2
    if (data.report_template_type == 2 && data.viscera) {
        data.sick_text_array = data.viscera.syndrome_name2
            ? data.viscera.syndrome_name2.split(',')
            : [];
        data.viscera.syndrome_desc = data.viscera.syndrome_desc2;
    }
}
